import { render, staticRenderFns } from "./ConfirmedEmail.vue?vue&type=template&id=270cbd04&scoped=true"
import script from "./ConfirmedEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmedEmail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedEmail.vue?vue&type=style&index=0&id=270cbd04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cbd04",
  null
  
)

export default component.exports